module.exports = __webpack_public_path__ + "img/icon_zhuhu.19d693c3.svg";